/**
 * Think dock hosted revision — forwarded on each `useAgentChat` / `sendMessage` body.
 * Server: `packages/rscircuit-agent/src/view-rev.ts` (`viewRevOf`).
 */

import { verbatimRevisionIdFromRoute } from "./kicad-path.ts";

/** Must match agent `view-rev.ts` / dock `sendMessage` body. */
export const PCBX_VIEW_REV_BODY_KEY = "pcbx_view_rev";

export function thinkChatBodyViewRev(opts: {
  routeRevId?: string | null;
  pathname?: string | null;
  search?: string | null;
}): Record<string, string> {
  const rev = verbatimRevisionIdFromRoute(opts);
  if (!rev) return {};
  return { [PCBX_VIEW_REV_BODY_KEY]: rev };
}
